// Community hosts set the --community-mention-* colors from their theme.
// Swarm has none and shows the neutral fallback.
// The border is an inset shadow, so it does not change the size of what it outlines.
export const MENTION_BORDER_CLASS_NAME = 'shadow-[inset_0_0_0_1px_var(--community-mention-border,transparent)]';

export const MENTION_CLASS_NAME = `rounded px-1 py-0.5 bg-[var(--community-mention-bg,rgb(0_0_0/0.06))] text-[color:var(--community-mention-text,rgb(0_0_0/0.8))] ${MENTION_BORDER_CLASS_NAME}`;

// A mention whose member or badge is gone reads as plain gray text, with no chip.
export const MENTION_UNAVAILABLE_CLASS_NAME = 'text-black/50';

// Hover only applies to links, not the span of hosts without one.
// :not([type]) outranks the `a:not([type]) { color: inherit }` reset in style.css.
export const MENTION_LINK_CLASS_NAME =
  'no-underline transition-[color,background-color,box-shadow] [&:not([type])]:text-[color:var(--community-mention-text,rgb(0_0_0/0.8))] [&:is(a):hover]:bg-[var(--community-mention-text,rgb(0_0_0/0.8))] [&:is(a):hover]:text-white [&:is(a):hover]:shadow-none';
